module.exports = __webpack_public_path__ + "img/D201610_1.3ca7e914.jpg";